import { renderContentWithTrackedLinks } from "utils/format";
import React from "react";

const DepartmentMessageTab = ({jobInfomation}: any) => {
  return (
    <div>
      <p className="text-sm font-normal alu-text-base-2 whitespace-pre-wrap break-all">
        {renderContentWithTrackedLinks(jobInfomation.message_from_department)}
      </p>
    </div>
  );
};

export default DepartmentMessageTab;
